<ng-template #loading>
    <app-component-loading></app-component-loading>
</ng-template>

<div class="table-container">
    <!--    Шапка с табами    -->
    <div class="widget-container head-grid-tab"
         [class.selected]="tab === 'PRODUCT'"
         (click)="getCards('PRODUCT')"
    >
        <div class="widget-body">
            <div class="main-tab-grid-header">
                <h2>Продукция</h2>
                <div class="circle-container">
                    @if (statisticData) {
                        <span>
                            {{ statisticData.product }}
                        </span>
                    } @else {
                        N/A
                    }
                </div>
            </div>
        </div>
    </div>
    <div class="widget-container head-grid-tab"
         [class.selected]="tab === 'SERVICE'"
         (click)="getCards('SERVICE')"
    >
        <div class="widget-body">
            <div class="main-tab-grid-header">
                <h2>Услуги</h2>
                <div class="circle-container">
                    @if (statisticData) {
                        <span>
                            {{ statisticData.service }}
                        </span>
                    } @else {
                        N/A
                    }
                </div>
            </div>
        </div>
    </div>
    <div class="widget-container head-grid-tab"
         [class.selected]="tab === 'STORAGE'"
         (click)="tab = 'STORAGE'"
    >
        <div class="widget-body">
            <div class="main-tab-grid-header">
                <h2>Склад</h2>

                <div class="circle-container">
                    @if (statisticData) {
                        <span>
                            {{ statisticData.warehouse }}
                        </span>
                    } @else {
                        N/A
                    }
                </div>
            </div>
        </div>
    </div>
    <!--  Шапка END  -->

    @switch (tab) {
        @case ('PRODUCT') {
            <div class="widget-container column-3"
                 style="background: none"
            >
                @if (products) {
                    <div class="widget-header">
                        <div class="search"
                             (click)="searchInput.focus()"
                        >
                            <i class="ri-search-line"></i>
                            <input type="search"
                                   placeholder="{{ 'INDEX_PAGE.OFFICE.TEXT.SEARCH' | translate }}"
                                   #searchInput
                                   (input)="searchInProducts(searchInput.value)"
                            >
                        </div>
                    </div>
                    <div class="widget-body">
                        <div class="cards-table">
                            @for (card of products; track card.puid) {
                                <div class="product-card"
                                     (click)="openCardModal(card, cardDialog)"
                                >
                                    <h2>{{ card.product_card.title }}</h2>
                                    <div class="image-container">
                                        @if (card.photo_first) {
                                            @if (card.photo_first.originImage) {
                                                <img [src]="card.photo_first.originImage"
                                                     alt="#"
                                                >
                                            }
                                        } @else {
                                            <img ngSrc="../../../../assets/images/placeholders/no_image.jpg"
                                                 alt="#"
                                                 height="170"
                                                 width="230"
                                            >
                                        }
                                    </div>
                                    <span class="description">
                                        {{ card.product_card.description ?? 'Описания нет' }}
                                    </span>
                                </div>
                            } @empty {
                                <h2>Список пуст</h2>
                            }
                        </div>
                    </div>
                } @else {
                    <ng-container *ngTemplateOutlet="loading"></ng-container>
                }
            </div>
        }
        @case ('SERVICE') {
            <div class="widget-container column-3">
                @if (services) {
                    <div class="widget-header">
                        <div class="search"
                             (click)="searchInput.focus()"
                        >
                            <i class="ri-search-line"></i>
                            <input type="search"
                                   placeholder="{{ 'INDEX_PAGE.OFFICE.TEXT.SEARCH' | translate }}"
                                   #searchInput
                                   (input)="searchInServices(searchInput.value)"
                            >
                        </div>
                    </div>
                    <div class="widget-body">
                        <section class="members_table">
                            <table mat-table
                                   [dataSource]="services"
                            >
                                <!-- photo_first Column -->
                                <ng-container matColumnDef="photo_first">
                                    <th mat-header-cell
                                        *matHeaderCellDef
                                    >
                                        Фото
                                    </th>
                                    <td mat-cell
                                        *matCellDef="let element"
                                        [width]="100"
                                    >
                                        <div class="image-container mini">
                                            @if (element.photo_first) {
                                                <img [src]="element.photo_first.originImage"
                                                     alt="#"
                                                >
                                            } @else {
                                                <img ngSrc="../../../../assets/images/placeholders/no_image.jpg"
                                                     alt="#"
                                                     height="170"
                                                     width="230"
                                                >
                                            }
                                        </div>
                                    </td>
                                </ng-container>

                                <!-- title Column -->
                                <ng-container matColumnDef="title">
                                    <th mat-header-cell
                                        *matHeaderCellDef
                                        [width]="300"
                                    >
                                        Наименование
                                    </th>
                                    <td mat-cell
                                        *matCellDef="let element"
                                    >
                                        <span style="cursor: pointer;"
                                              (click)="openCardModal(element, cardDialog)"
                                        >
                                            {{ element.product_card.title }}
                                        </span>
                                    </td>
                                </ng-container>

                                <!-- article Column -->
                                <ng-container matColumnDef="article">
                                    <th mat-header-cell
                                        *matHeaderCellDef
                                        [width]="100"
                                    >
                                        Артикул
                                    </th>
                                    <td mat-cell
                                        *matCellDef="let element"
                                    >
                                        -
                                    </td>
                                </ng-container>

                                <!-- description Column -->
                                <ng-container matColumnDef="description">
                                    <th mat-header-cell
                                        *matHeaderCellDef
                                    >
                                        Описание
                                    </th>
                                    <td mat-cell
                                        *matCellDef="let element"
                                    >
                                        {{ element.product_card.description ?? '-' }}
                                    </td>
                                </ng-container>

                                <tr mat-header-row
                                    *matHeaderRowDef="['photo_first', 'title', 'article', 'description'], sticky: true"
                                ></tr>
                                <tr mat-row
                                    *matRowDef="let row; columns: ['photo_first', 'title', 'article', 'description'];"
                                ></tr>
                                <tr class="mat-row"
                                    *matNoDataRow
                                >
                                    <td class="mat-sell"
                                        colspan="4"
                                    >
                                        <strong>{{ 'EMPTY_LISTS.EMPTY' | translate }}</strong>
                                    </td>
                                </tr>
                            </table>
                        </section>
                    </div>
                } @else {
                    <ng-container *ngTemplateOutlet="loading"></ng-container>
                }
            </div>
        }
        @case ('STORAGE') {

        }
    }
</div>

<ng-template #cardDialog>
    @if (selectedCard) {
        <div>
            <h2>{{ selectedCard.product_card.title }}</h2>
            <small>Артикул: №123</small>

            <div>
                <div style="display: flex; flex-direction: column-reverse;">
                    @if (selectedCard.photo_first) {
                        <div class="position-relative m-1 carousel">
                            @for (photo of selectedCard.photos; track photo.ukey) {
                                <div class="carousel_item"
                                     [class.current]="photo.ukey === activeBigPhoto.ukey"
                                     (mouseover)="activeBigPhoto = photo"
                                >
                                    <img style="position: unset;"
                                         [src]="photo.originImage"
                                         alt="#"
                                    >
                                </div>
                            }
                        </div>
                    }
                    <div class="position-relative m-2 big-picture">
                        @if (activeBigPhoto) {
                            <div class="photo-button previous"
                                 (click)="prevPhoto()"
                            >
                                <i class="ri-arrow-left-long-fill"></i>
                            </div>
                            <div class="photo-button next"
                                 (click)="nextPhoto()"
                            >
                                <i class="ri-arrow-right-long-fill"></i>
                            </div>
                            <img [src]="activeBigPhoto.originImage"
                                 alt="#"
                            >
                        } @else {
                            <img ngSrc="../../../../assets/images/placeholders/no_image.jpg"
                                 alt="#"
                                 height="400"
                                 width="640"
                            >
                        }
                    </div>
                </div>
            </div>

            <div>
                {{ selectedCard.product_card.description ?? '-' }}
            </div>
        </div>
    } @else {
        <ng-container *ngTemplateOutlet="loading"></ng-container>
    }
</ng-template>
